import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

export const SearchTag = styled('div')(({ theme }) => ({
  background: theme.palette.common.mds_global_color_white,
  padding: `${theme.spacing(0.7)} ${theme.spacing(1.5)} ${theme.spacing(0.7)} ${theme.spacing(1.5)}`,
  borderRadius: theme.spacing(4),
  border: '1px solid',
  borderColor: theme.palette.common.mds_global_background_gray_1,
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.palette.common.mds_global_background_gray_1,
  },
}));

export const SearchTagContent = styled(Typography)(({ theme }) => ({
  flex: 1,
  fontSize: '14px',
  color: theme.palette.secondary.main,
}));

export const ClearIconButton: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '16px',
  height: '16px',
  padding: '0',
  border: 'none',
  borderRadius: '50%',
  backgroundColor: '#8E8E8E',
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'background-color 150ms ease',
  WebkitTapHighlightColor: 'transparent',
};
